<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">SEO</li>
        <li class="breadcrumb-item active">Images</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="caption">
          <h6>CMS images list</h6>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-xl-12">
            <table-component ref="records" :show-filter="false" :data="fetchRows" sort-by="image_src" sort-order="asc" table-class="table" @rowClick="rowClicked">
              <table-column :sortable="false" :filterable="false" label="Preview">
                <template slot-scope="row">
                  <img :src="row.image_src" style="max-width:200px;" >
                </template>
              </table-column>
              <table-column show="image_src" label="URL"/>
              <table-column :sortable="false" :filterable="false" label="Pages">
                <template slot-scope="row">
                  {{ (row.url || []).join(', ') }}
                </template>
              </table-column>
              <table-column
                :sortable="false"
                :filterable="false"
                label="Actions"
              >
                <template slot-scope="row">
                  <router-link
                    :to="{ name: 'seo-image-edit', params: { imageId: row.id } }"
                    @click.stop="() => true"
                  >
                    <i v-tooltip.top-center="'Edit'" class="icon-im icon-im-pencil" />
                  </router-link>
                </template>
              </table-column>
            </table-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global axios */
export default {
  name: 'SeoImageList',
  data () {
    return {
      images: []
    }
  },
  methods: {
    async fetchRows ({ page, filter, sort }) {
      const response = await axios.post('/api/admin/seo/image', {
        page: page,
        filter: filter,
        sort: sort
      })

      return {
        data: response.data.records,
        pagination: {
          totalPages: response.data.totalPages,
          currentPage: response.data.currentPage,
          count: response.data.count
        }
      }
    },
    rowClicked (row) {
      if (row.data && row.data.id) {
        this.$router.push('/admin/seo/images/' + row.data.id + '/edit')
      }
    }
  }
}
</script>

<style>
.delete--link:hover {
  cursor: pointer;
}
</style>
